import { Card, Grid, Button, TextField, Select, IconButton, CircularProgress, Popover, Box, Tooltip, MenuItem, Skeleton } from "@mui/material";
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import { useCreateSwarmPurchaseMutation, useEditBuyRequestMutation, useLostPurchaseMutation } from "../../services/swarmsApi";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentUser } from '../../features/auth/authSlice';
import { useResolutionTypes } from '../../customHooks/useResolutionTypes';
import { selectActiveEmailsByUserId, updateBuyingEmail } from "../../store/slices/buyingEmails/buyingEmails";
import { copyToClipBoard } from "../../utils";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Modal from '@mui/material/Modal';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

import BuyingEmailForm from "../adminToolsTabs/components/BuyingEmailForm";
import ShowDeliveryMethod from "./showDeliveryMethod";
import { toStdDate } from "../../utils/dates";
import { useLazyGetUserBuysQuery } from "../../services/eventApi";
import withMemoization from "../../customHooks/withMemorization";
import { useNotification } from '../../context/NotificationContext';
import { LostMenu } from "../../components/lostMenu";
import { useGetPlatformNamesQuery, useLazyDecryptMultiplePlatformsPasswordsQuery } from "../../services/platformsApi";
import {useGetMyCreditCardsQuery} from "../../services/creditCards";
import UserDecryptCreditCardPopover from "../../components/creditCards/UserDecryptCreditCardPopover";

const EmailUsedComponent =({user, buyingEmails,setOpenAddEmailModal,formPurchase,setFormPurchase}) => {
  
  const [openEmailAccountSelect, setOpenEmailAccountSelect] = useState(false);
  let [target, setTarget] = useState(null);

  function getBuyingEmailById(buyingEmailId) {
    if (buyingEmailId == null || buyingEmailId == '') return '';
    if (buyingEmails == null) return '';
    const found = buyingEmails.find(buyingEmail => buyingEmail.id == buyingEmailId);
    if (found == undefined || found == null) return '';
    return found.emailAddress;
  }
  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }} >

        <p style={{ margin: "0 0 0.5em 0", fontSize: 'var(--p2)', whiteSpace: 'nowrap' }}> Buying Email Used </p>

        <IconButton
          sx={{ height: '28px', width: '28px', margin: ' 0 0.25em' }}
          color="primary"
          onClick={e => {
            setTarget(e.target);
            copyToClipBoard(getBuyingEmailById(formPurchase.buyingEmailId))
          }}
        >
          <ContentCopyIcon sx={{ height: '20px' }} />
        </IconButton>

        <IconButton
          sx={{ height: '28px', width: '28px' }}
          color="primary"
          onClick={() => {
            setOpenAddEmailModal({
              userId: user.id,
              title: `${user.firstName + " " + (user.lastName || "")} Buying Email details`
            })
          }}
        >
          <AddOutlinedIcon sx={{ height: '20px' }} />
        </IconButton>

        <Popover
          id="EmailCopylAnchor"
          open={target}
          anchorEl={target}
          onClose={() => setTarget(null)}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <p style={{ margin: "0", padding: "0.5em", fontSize: "0.85rem" }} >
            {formPurchase.buyingEmailId ? (
              <span style={{ fontWeight: 700, color: 'var(--orange)' }}>
                Copied!
              </span>
            ) : (
              <span>Please select a Buying Email.</span>
            )}
          </p>
        </Popover>

      </div>
      <div style={{ display: "flex", flexDirection: 'row', alignItems: 'center', width: '100%' }}>
        <Select
          variant="outlined"
          sx={{ height: '41px', width: '100%' }}
          value={formPurchase.buyingEmailId}
          defaultValue={"default"}
          name="emailAccountUsed"
          className={`buyingEmailsUsedSelect`}
          onChange={(e) => {
            setFormPurchase({
              ...formPurchase,
              PlatformCredentialId: "", // reset password
              buyingEmailId: e.target.value,
            });
          }}
          open={openEmailAccountSelect}
          onClose={() => setOpenEmailAccountSelect(false)}
          onOpen={() => setOpenEmailAccountSelect(true)}
        >
          {buyingEmails.map(({ id, emailAddress }, index) => (
            <MenuItem className={`buyingEmailUsed-${index}`} value={id} key={id}>{emailAddress} </MenuItem>
          ))}
        </Select>

      </div>
    </>
  )
}

const CreditCardUsed = ({formPurchase, setFormPurchase,creditCards}) => {

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }} >
        <p style={{ margin: "0 0 0.5em 0", fontSize: 'var(--p2)', whiteSpace: 'nowrap' }}> Credit Card Used </p>

        <UserDecryptCreditCardPopover creditCardId={formPurchase.creditCardId} />

      </div>

        <div style={{ display: "flex", alignItems: 'center', width: '100%' }}>
          <Select
            value={formPurchase.creditCardId || ""}
            defaultValue={"default"}
            name="creditCardUsed"
            className="creditCardsSelect"
            sx={{ height: '41px', width: '100%', }}  // border: showRed("creditCardId"),            
            onChange={(e) =>
              setFormPurchase({
                ...formPurchase,
                creditCardId: e.target.value,
              })
            }
          >
            {creditCards.map((cc, index) => (
              <MenuItem key={cc.id} value={cc.id} className={`creditCard-${index}`}>
                {`${cc.cardTypeName} XXXX-${cc.last4Digits} ${cc.expirMonth}/${cc.expirYear}`}
              </MenuItem>
            ))}
          </Select>

      </div>
    </>
  )
}

const PlatformPasswordUser = ({ user, formPurchase, buyingEmails, plaftorms, setFormPurchase, setOpenAddEmailModal }) => {

  const selectedBuyingEmail = buyingEmails.filter(BE => parseInt(BE.id) == parseInt(formPurchase.buyingEmailId));
  const allCredentialsForUser = selectedBuyingEmail?.map(BE => BE.platformsCredentials).flat()

  console.log("allCredentialsForUser: ", allCredentialsForUser);
  const [openCredentialsSelect, setOpenCredentialsSelect] = useState(false);

  let [target, setTarget] = useState(null);

  function GetCredentialsOptions() {
    if (!formPurchase.buyingEmailId) return null;
    if (!allCredentialsForUser) return null;

    let activeCredentials = allCredentialsForUser?.filter(cred => cred && !cred.isDeleted )
    if (!activeCredentials || activeCredentials.length == 0) return null;
    function getPlatformName(platformId) {
      let aux = plaftorms || [];
      let platform = aux.find(p => p.id == platformId);
      return platform?.name || platformId;
    };
    function getShortName(ac) {
      let aux = plaftorms || [];
      let platform = aux.find(p => p.id == ac.platformId);
      if (platform?.name == "TM/LN") return "";
      return ac?.shortName ? " - " + ac?.shortName : "";
    };
    return activeCredentials.map((ac, idx) => (
      <MenuItem value={ac.id} key={idx}>{`${getPlatformName(ac.platformId)} - ${ac.platformPassword} ${getShortName(ac)}`} </MenuItem>
    ))
  }

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }} >

        <p style={{ margin: "0 0 0.5em 0", fontSize: 'var(--p2)', whiteSpace: 'nowrap' }}> Box Office Password Used </p>

        <IconButton
          sx={{ height: '28px', width: '28px', margin: ' 0 0.1em' }}
          color="primary"
          onClick={e => {
            setTarget(e.target)
            let credential = allCredentialsForUser.find(cred => cred.id == formPurchase.PlatformCredentialId);
            if (credential) copyToClipBoard(credential.platformPassword)
          }}
        >
          <ContentCopyIcon
            id="platformCredentialAnchor"
            sx={{ height: '20px' }}
          />
        </IconButton>

        <IconButton
          sx={{ height: '28px', width: '28px', margin: '0' }}
          color="primary"
          disabled={!formPurchase.buyingEmailId}
          onClick={() => {
            setOpenAddEmailModal({
              emailId: formPurchase.buyingEmailId,
              userId: user.id,
              title: `${user.firstName + " " + (user.lastName || "")} Buying Email details`,
            })
          }}
        >
          <EditOutlinedIcon sx={{ height: '20px' }} />
        </IconButton>

        <Popover
          id="platformCredentialAnchor"
          open={target}
          anchorEl={target}
          onClose={() => setTarget(false)}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <p style={{ margin: "0", padding: "0.5em", fontSize: "0.85rem" }} >
            {formPurchase.PlatformCredentialId ? (
              <span style={{ fontWeight: 700, color: 'var(--orange)' }}>
                Copied!
              </span>
            ) : (
              <span>Please select a Box Office Password.</span>
            )}
          </p>
        </Popover>

      </div>

      <div style={{ display: "flex", flexDirection: 'row', alignItems: 'center', width: '100%' }}>

        <Select
          value={formPurchase.PlatformCredentialId}
          name="emailAccountUsed"
          sx={{ height: '41px', width: '100%', }} //border: showRed("PlatformCredentialId")                        
          onChange={(e) =>
            setFormPurchase({
              ...formPurchase,
              PlatformCredentialId: e.target.value,
            })
          }
          open={openCredentialsSelect}
          onClose={() => setOpenCredentialsSelect(false)}
          onOpen={() => setOpenCredentialsSelect(true)}
        >
          {GetCredentialsOptions()}
        </Select>

      </div>
    </>
  )
}

function PendingBuyApproved({ buyRequest, event }) {

  const user = useSelector(selectCurrentUser);
  const {data: creditCards} = useGetMyCreditCardsQuery({isDeleted: false, isActive: true});

  const [editBuyRequest, { isLoading: editBuyRequestLoading }] = useEditBuyRequestMutation();
  const [isLoading, setIsLoading] = useState(false)
  const [ lostReasons ] = useLostPurchaseMutation();
  const resolutionTypes = useResolutionTypes();
  const dispatch = useDispatch();

  const {data: plaftorms } = useGetPlatformNamesQuery();
  const buyingEmails = useSelector((state) => selectActiveEmailsByUserId(state, user.id));

  const [formPurchase, setFormPurchase] = useState({});
  const [openAddEmailModal, setOpenAddEmailModal] = useState(null);
  const [createSwarmPurchaseTrigger] = useCreateSwarmPurchaseMutation();
  const [getUserBuys] = useLazyGetUserBuysQuery()
  const [decryptPlatformsPasswords] = useLazyDecryptMultiplePlatformsPasswordsQuery()

  const { showNotification } = useNotification();
  
  useEffect(() => console.log(formPurchase), [formPurchase])

  async function onSaveClick() {
    setIsLoading(true)
    let params = {
      ...buyRequest,
      requestID: parseInt(buyRequest.id),
      buyingEmailId: parseInt(formPurchase.buyingEmailId),
      platformCredentialId: parseInt(formPurchase.PlatformCredentialId),
      creditCardId: parseInt(formPurchase.creditCardId),
      orderNumber: formPurchase.confirmationNumber,
      swarmBuyRequestId: parseInt(buyRequest.id),
      requestTypeId: 2, //TODO: this is hardcoded, we need to get this from the backend 
      purchaseTotal: parseFloat(buyRequest.totalCost) * 100,
    }
    try {
      await createSwarmPurchaseTrigger(params).unwrap();
      //update UserBuys
      await getUserBuys().catch((error) => {
        if (error.status == 401) return //error managed on baseQueryWithReauth
        throw error
      });
      setIsLoading(false)
    } catch (error) {
      if (error.status == 401) return; //error managed on baseQueryWithReauth
      showNotification(error?.data?.message, 'error');
      setIsLoading(false)
      throw error;
    }
  }

  const onLostClick = async (mainReasonId, subReasonId) => {
    try {
      setIsLoading(true);
      let res = await editBuyRequest({ 
        id: buyRequest.id, 
        swarmResolutionTypeId: resolutionTypes?.find(srt => srt.name == 'Lost')?.id, 
        MainReasonId: mainReasonId, 
        SubReasonId: subReasonId }).unwrap()
        await lostReasons({ BuyRequestId: buyRequest.id, MainReasonId: mainReasonId, SubReasonId: subReasonId }).unwrap();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (error.status == 401) return; //error managed on baseQueryWithReauth
      throw error;
    }
  }

  // --- Decrypt Platform Passwords for selected Email

  async function decryptAndDispatchCredentials(res) {
    if (!formPurchase.buyingEmailId) return;

    const buyingEmailIndex = buyingEmails.findIndex(BE => BE.id === formPurchase.buyingEmailId);
    if (buyingEmailIndex === -1) return;

    const credentials = buyingEmails[buyingEmailIndex].platformsCredentials;
    if (!credentials || credentials.length === 0) return;
    
    let queryString = ""; 

    if (res) {
      queryString = res.platformCredentials.map(platform => `id=${platform.id}`).join('&');
    }
    else {
      queryString = credentials.map(cred => `id=${cred.id}`).join('&');
    }
  
    try {
      const decryptedCredentials = await decryptPlatformsPasswords(`?${queryString}`).unwrap();


      const updatedCredentials = decryptedCredentials.map(decrypted => {
          const existentCredIdx = credentials.findIndex(cred => cred.id === decrypted.id)
          if(existentCredIdx !== -1){
            return ({ ...credentials[existentCredIdx],  platformPassword: decrypted?.password })
          }else{
            let newCred = res.platformCredentials.find( DC => DC.id == decrypted.id)
            return ( { ...newCred, platformPassword: decrypted?.password } )
          }
      })

      dispatch(updateBuyingEmail({
        ...buyingEmails[buyingEmailIndex],
        platformsCredentials: updatedCredentials,
      }));
    } catch (error) {
      if (error.status !== 401) {
        console.error('Error decrypting platform passwords:', error);
      }
    }
  }
  
  useEffect(() => {
    decryptAndDispatchCredentials();
  }, [formPurchase.buyingEmailId]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };

  function formIsCompleted() {
    return formPurchase.buyingEmailId && formPurchase.PlatformCredentialId && formPurchase.creditCardId && formPurchase.confirmationNumber;
  }

  const cardStyles = {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'column', md: 'column', lg: 'row', xl: 'row' },
    alignItems: 'flex-end',
    justifyContent: { xs: 'flex-end', sm: 'flex-end', md: 'flex-end', lg: 'space-between', xl: 'space-between' }, //'space-between'
  };

  const cardInfo = {
    display: 'flex',
    flexWrap:'wrap',
    flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row' },
    alignItems: 'flex-start',
    margin: { xs: '0 0 0.5em 0', sm: '0 0 0.5em 0', md: '0 0 0.5em 0', lg: '0 1em 0.5em 0', xl: '0 1em 0.5em 0' }
  }

  const inputsContainerStyles = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: { xs: 'flex-end', sm: 'flex-end', md: 'flex-end', lg: 'center', xl: 'flex-end' }, //'flex-end'
    margin: { xs: '0 0 1em 0', sm: '0 0 1em 0', md: '0 0 1em 0', lg: '0 2em 0 0', xl: '0 2em 0 0' },
    flexWrap: { xs: 'wrap', sm: 'wrap', md: 'wrap', lg: 'wrap', xl: 'nowrap' },
  };

  const inputStyles = {
    margin: { xs: '0 0 0.5em 0', sm: '0 1em 0.5em 0', md: '0 1em 0.5em 0', lg: '0 1em 0.5em 0', xl: '0 1em 0 0' }, //'0 1em 0 0'
    width: { xs: '100%', sm: '47%', md: '48%', lg: '47%', xl: '100%' },
  };

  const buttonStyles = {
    display: 'flex',
    flexDirection: { xs: 'row', sm: 'row', md: 'row', lg: 'column', xl: 'column' },
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    height: '100%',
    width: { xs: '100%', sm: '100%', md: '100%', lg: '150px', xl: '150px' },
  };

  const isMobile = useIsMobile();
  
  function useIsMobile(breakpoint = 600) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < breakpoint);
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
  }

  let title = !event?.name ? "Error on Event Data" : `${event?.name} - ${event?.venue?.name + ", " + event?.venue?.city} - ${event ? toStdDate(event.date) : 'Null'}`;

  let mobileTitle = !event?.name ? "Error on Event Data" : `${event?.name?.substring(0, 20)} - ${event?.venue?.name?.substring(0, 20) + ", " + event?.venue?.city} - ${event ? toStdDate(event.date) : 'Null'}`;

  return (
    <>

      <Modal open={Boolean(openAddEmailModal)} onClose={() => setOpenAddEmailModal(null)} >
        <Box sx={style}>
          <BuyingEmailForm
            title={openAddEmailModal?.title}
            userId={openAddEmailModal?.userId}
            emailId={parseInt(openAddEmailModal?.emailId)}
            onClose={() => setOpenAddEmailModal(null)}
            beeIsEditing={true}
            onSuccess={(res, message) => { decryptAndDispatchCredentials(res) }}
          />
        </Box>
      </Modal>

      <Card sx={{ margin: '0  0 2em 0', borderRadius: '1.5em', padding: '1em' }} >
        <Grid item xs={12} sx={cardStyles}>
          <Grid item sx={{ display: 'flex', flexDirection: 'column', width: '100%' }} >
            <h4 style={{ fontWeight: '600', color: 'var(--orange)', margin: '0 0 0.5em 0 ' }} >
            {
              !event
              ?
                <Skeleton variant="text" width="50%" ></Skeleton>
              :
                <Tooltip title={title} placement="top" enterTouchDelay={0}>
                  <span>{isMobile ? mobileTitle : title}</span>
                </Tooltip>            
                }
            </h4>
            <Grid item sx={cardInfo} >

              <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', margin: '0 2em 0 0', whiteSpace:'nowrap' }} >
                <ConfirmationNumberOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
                <p style={{ fontWeight: '700', margin: '0.15em 0 0 0' }} >{`${buyRequest.quantity} tickets in Section ${buyRequest.section} - Row ${buyRequest.row} - Seats ${buyRequest.seats}`}</p>
              </Grid>

              <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0 2em 0 0' }} >
                <InboxOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
                <p style={{ fontWeight: '700', whiteSpace: 'nowrap' }} > <ShowDeliveryMethod deliveryMethodID={buyRequest.deliveryMethodID} /> </p>
              </Grid>

              <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0 2em 0 0' }} >
                <SellOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
                <p style={{ fontWeight: '700', whiteSpace: 'nowrap' }} >Total Cost ${buyRequest.totalCost}</p>
              </Grid>
              
              {
                buyRequest.isLimitedView &&
                  <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0 2em 0 0' }} >
                    <VisibilityOffOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
                    <p style={{ fontWeight: '700', whiteSpace: 'nowrap' }} >Obstructed/Limited View</p>
                  </Grid>
              }

              <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0 2em 0 0' }} >
                <PaidOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
                <p style={{ fontWeight: '700', whiteSpace: 'nowrap' }} >Reward {`$${buyRequest?.swarmRewardTypeId === 1 ? (buyRequest?.rewardAmout / buyRequest?.quantity ) : buyRequest?.rewardAmout  } ${buyRequest?.swarmRewardTypeId === 1 ? `Per Ticket` : `Total`}`}</p>
              </Grid>
              
            </Grid>

            <Grid item sx={inputsContainerStyles} >

              <Grid
                item
                sx={{
                  margin: { xs: '0 1em 0.5em 0', sm: '0 1em 0.5em 0', md: '0 1em 0.5em 0', lg: '0 1em 0.5em 0', xl: '0 1em 0 0' },
                  width: { xs: '100%', sm: '100%', md: '100%', lg: '100%', xl: '150px' },
                }
                }
              >
                <h4 style={{ fontWeight: '700', color: 'white', backgroundColor: 'var(--green)', padding: '0.35em 0.75em', borderRadius: '8px' }} >
                  APPROVED
                </h4>
              </Grid>

              <Grid item sx={inputStyles}>
                <EmailUsedComponent 
                  user={user} 
                  buyingEmails={buyingEmails}
                  setOpenAddEmailModal={setOpenAddEmailModal}
                  formPurchase={formPurchase} 
                  setFormPurchase={setFormPurchase}
                />
              </Grid>

              <Grid item sx={inputStyles}>
                <PlatformPasswordUser
                  user={user}
                  formPurchase={formPurchase}
                  buyingEmails={buyingEmails}
                  plaftorms={plaftorms}
                  setFormPurchase={setFormPurchase}
                  setOpenAddEmailModal={setOpenAddEmailModal}
                />
              </Grid>

              <Grid item sx={inputStyles}>
                <CreditCardUsed 
                  formPurchase={formPurchase} 
                  setFormPurchase={setFormPurchase}
                  creditCards={creditCards || []}
                />
              </Grid>

              <Grid item sx={inputStyles}>
                <p style={{ margin: "0 0 0.5em 0", fontSize: 'var(--p2)', whiteSpace: 'nowrap' }}>Order Number</p>
                <TextField className="orderNumberInput" variant="outlined" sx={{ width: '100%' }} value={formPurchase.confirmationNumber} onChange={(e) => setFormPurchase({ ...formPurchase, confirmationNumber: e.target.value })} />
              </Grid>

            </Grid>

          </Grid>

          <Grid sx={buttonStyles}>

            <LostMenu onSelect={onLostClick} loading={isLoading} style={{
              width:'100%',
              margin: { xs: '0 1em 0 0', sm: '0 1em 0 0', md: '0 1em 0 0', lg: '0 0 0.5em 0', xl: '0 0 0.5em 0' }}
            }>
              <Button
                variant='outlined'
                color="primary"
                sx={{
                  borderRadius: '0.5em',
                  width: '100%',
                  height: '41px',
                  fontWeight: 600
                }}
              > {isLoading ? <CircularProgress size={20} /> : 'LOST'}
              </Button> 
            </LostMenu>

            <Button
              onClick={() => onSaveClick()}
              disabled={isLoading || !formIsCompleted()}
              variant='contained'
              color="primary"
              sx={{ borderRadius: '0.5em', whiteSpace: 'nowrap', height: '41px', width: '100%' }}
            >
              SAVE PURCHASE
            </Button>

          </Grid>

        </Grid>

      </Card >
    </>
  )
}

const memorizedApproved = withMemoization(PendingBuyApproved);

export default memorizedApproved